/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type CheckPointStatus =
  (typeof CheckPointStatus)[keyof typeof CheckPointStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CheckPointStatus = {
  PLANNED: "PLANNED",
  DELAYED: "DELAYED",
  FINISHED: "FINISHED",
} as const;
